import { CheckboxMenu } from "@design-system/shadcn";
import { ListFilter } from "lucide-react";
import React from "react";

import { useFilters } from "../filters-provider";

interface FilterBarMenuProps {
  label: string;
  tooltip?: string;
  icon?: React.ComponentType<{ className?: string }>;
  className?: string;
  disabled?: boolean;
}

function FilterBarMenu({
  label,
  tooltip,
  icon = ListFilter,
  className,
  disabled,
}: FilterBarMenuProps) {
  const { filters, visibleFilters, setFilterVisible } = useFilters();

  return (
    <CheckboxMenu
      icon={icon}
      label={label}
      tooltip={tooltip}
      className={className}
      disabled={disabled}
      items={filters.map((filter) => ({
        ...filter,
        checked: visibleFilters.includes(filter.id),
      }))}
      onItemCheckedChange={setFilterVisible}
    />
  );
}

export { FilterBarMenu };
export type { FilterBarMenuProps };
